import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TipoProducto } from '../../../../models/tipo-producto.model';
import { CatalogosService } from '../../../../services/catalogos.service';

@Component({
  templateUrl: './post-registro-productos.component.html',
  styleUrls: ['./post-registro-productos.component.css'],
})
export class PostRegistroProductosComponent implements OnInit {
  breadCrumbItems = [];
  tipos: TipoProducto[];
  loading = false;
  area: string;
  tipo: string;

  constructor(
    private catalogosService: CatalogosService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {    
    this.tipo = this.route.snapshot.paramMap.get('tipo');
    this.area = this.route.snapshot.paramMap.get('area');

    if (String(this.tipo) === 'estupefacientes') {
      this.breadCrumbItems = [
        {
          label: 'Usuario ventanilla',
          routerLink: '/inicio',
        },
        {
          label: this.capitalizeFirstLetter(this.tipo),
          routerLink: '/' + this.tipo,
        },
      ];
    } else if(this.tipo === 'apertura') {
      this.area = 'apertura';
    } else if(this.tipo === 'modificacion') {
      this.area = 'modificacion';
    } else if(this.tipo === 'certificaciones-constancias') {
      this.area = 'certificaciones-constancias';
    } else {
      this.breadCrumbItems = [
        {
          label: 'Usuario ventanilla',
          routerLink: '/inicio',
        },
        {
          label:this.capitalizeFirstLetter(this.tipo) + ' (Trámites Post-Registro)',
          routerLink: '/post-registro/' + this.tipo,
        },
      ];
    }

    this.loading = true;
    switch (this.area) {
      case 'area-medica':
        this.breadCrumbItems.push({
          label: 'Área Médica',
          routerLink: '/post-registro/' + this.tipo + '/area-medica',
        });
        break;
      case 'area-juridica':
        this.breadCrumbItems.push({
          label: 'Cambios post-registro jurídicos',
          routerLink: '/post-registro/' + this.tipo + '/area-juridica',
        });
        break;
      case 'area-farmacovigilancia':
        this.breadCrumbItems.push({
          label: 'Área Farmacovigilancia',
          routerLink: '/post-registro/' + this.tipo + '/area-farmacovigilancia',
        });
        break;
      case 'area-laboratorio':
        this.breadCrumbItems.push({
          label: 'Área Laboratorio',
          routerLink: '/post-registro/' + this.tipo + '/area-laboratorio',
        });
        break;
      case 'area-quimica':
        this.breadCrumbItems.push({
          label: 'Área Química',
          routerLink: '/post-registro/' + this.tipo + '/area-quimica',
        });
        break;
      case 'area-administrativa':
        this.breadCrumbItems.push({
          label: 'Área Administrativa',
          routerLink: '/post-registro/' + this.tipo + '/area-administrativa',
        });
        break;
      case 'dispositivos-medicos':
        this.breadCrumbItems.push({
          label: 'Área Técnica (DM)',
          routerLink: '/post-registro/' + this.tipo + '/dispositivos-medicos',
        });
        break;
      case 'cosmeticos':
        this.breadCrumbItems.push({
          label: 'Cosméticos',
          routerLink: '/post-registro/' + this.tipo + '/cosmeticos ',
        });
        break;
      case 'higienicos':
        this.breadCrumbItems.push({
          label: 'Higiénicos',
          routerLink: '/post-registro/' + this.tipo + '/higienicos ',
        });
        break;
      case 'prevision':
        this.breadCrumbItems = [
          {
            label: 'Usuario ventanilla',
            routerLink: '/inicio',
          },
          {
            label: 'Unidad de Estupefacientes',
            routerLink: '/' + this.tipo,
          },
          {
            label: 'Previsión de Importaciones',
            routerLink: '/post-registro/estupefacientes/prevision',
          },
        ];
        break;
      case 'autorizacion-fabricacion':
        this.breadCrumbItems = [
          {
            label: 'Usuario ventanilla',
            routerLink: '/inicio',
          },
          {
            label: 'Unidad de Estupefacientes',
            routerLink: '/' + this.tipo,
          },
          {
            label:
              'Autorización para fabricación de medicamentos o productos controlados',
            routerLink:
              '/post-registro/estupefacientes/autorizacion-fabricacion',
          },
        ];
        break;
      case 'autorizacion-comercializacion':
        this.breadCrumbItems = [
          {
            label: 'Usuario ventanilla',
            routerLink: '/inicio',
          },
          {
            label: 'Unidad de Estupefacientes',
            routerLink: '/' + this.tipo,
          },
          {
            label: 'Autorización de Comercialización',
            routerLink: '/post-registro/estupefacientes/autorizacion-comercializacion',
          },
        ];
        break;
        case 'apertura':
          this.breadCrumbItems = [
            {
              label: 'Usuario ventanilla',
              routerLink: '/inicio',
            },
            {
              label: 'Establecimientos',
              routerLink: '/establecimientos',
            },
            {
              label: 'Apertura de Establecimientos',
              routerLink: '/establecimientos/area/apertura',
            }
          ];
          break;
        case 'modificacion':
          this.breadCrumbItems = [
            {
              label: 'Usuario ventanilla',
              routerLink: '/inicio',
            },
            {
              label: 'Establecimientos',
              routerLink: '/establecimientos',
            },
            {
              label: 'Modificación de Establecimientos',
              routerLink: '/establecimientos/area/modificacion',
            }
          ];
          break;
          case 'certificaciones-constancias':
          this.breadCrumbItems = [
            {
              label: 'Usuario ventanilla',
              routerLink: '/inicio',
            },
            {
              label: 'Productos Quimicos',
              routerLink: '/quimicos',
            },
            {
              label: 'Certificaciones y Constancias',
              routerLink: '/post-registro/quimicos/certificaciones-constancias',
            }
          ];
          break;
      default:
        break;
    }
    this.catalogosService
      .getTiposProductosPR(this.tipo, this.area)
      .subscribe((tipos) => {
        this.loading = false;
        this.tipos = tipos;
      });
  }

  capitalizeFirstLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
  }
}
